import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import GeneralButton from "./GeneralButton";

// Init styled components

const DialogPopup = ({ open, closeHandler, message }) => {
	const { t } = useTranslation();
	return (
		<Dialog open={open} onClose={closeHandler}>
			<DialogActions>
				<GeneralButton onClick={closeHandler} variant="contained">
					{t("action.close")}
				</GeneralButton>
			</DialogActions>
			<DialogContent>
				<DialogContentText>{message}</DialogContentText>
			</DialogContent>
		</Dialog>
	);
};

export default DialogPopup;
